import useApiClient from "../../useApiClient";
import { useSelector } from "react-redux";
import { useCallback } from "react";
import { withNetworkErrorHandling } from "../../helpers/withNetworkErrorHandling";

const useTasksAPIClient = () => {
  const { get } = useApiClient();
  const { activeUser } = useSelector((state) => state.user);

  const getTasks = useCallback(async () => {
    const response = await withNetworkErrorHandling(() =>
      get(`users/${activeUser.userId}/tasks`),
    );
    return response?.message;
  }, [activeUser, get]);

  return { getTasks };
};

export default useTasksAPIClient;
